import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { nonResponseInducingEvents } from '../models/constants'

/**
 * Check if the last activity received/sent is used in the flow of the conversation and if so, if it's ended or not.
 * Used for text/loader display in vocal mode for example.
 * @returns {boolean}
 */
const useBotAnswerEnded = (): boolean => {
  const lastActivity = useSelector((state: RootState) => state.activityReducer.lastActivity)
  const endedActivities = useSelector((state: RootState) => state.activityReducer.endedActivities)
  const [ended, setEnded] = useState<boolean>(false)

  useEffect(() => {
    if (lastActivity) {
      // If the activity has a replyToId or if it's a bring-up message, it's a bot response.
      if (lastActivity.replyToId || lastActivity.label?.toLowerCase() === 'davi.bringupmessage') {
        if (lastActivity.type === 'message' || lastActivity.value?.name?.toLowerCase() === 'davi.streammessageactivity') {
          setEnded(endedActivities.includes(lastActivity.id))
        } else {
          setEnded(true)
        }
      } else if (lastActivity.type === 'message' || (lastActivity.value?.name && !nonResponseInducingEvents.find((eventName) => lastActivity.value.name.toLowerCase().includes(eventName)))) {
        setEnded(false)
      } else {
        setEnded(true)
      }
    } else {
      setEnded(true)
    }
  }, [lastActivity, endedActivities])

  return ended
}

export default useBotAnswerEnded
